import { createNamespacedHelpers } from 'vuex';
import { mixin as clickAway } from 'vue-clickaway';

import IconChats from '@/assets/icons/chats.svg';
import IconClose from '@/assets/icons/close.svg';
import IconTransfer from '@/assets/icons/transfer.svg';
import IconBooking from '@/assets/icons/booking.svg';

import ModalTransferChannel from '@/components/modal_transfer_channel/ModalTransferChannel.vue';
import ModalReservationForm from '@/components/modal_reservation_form/ModalReservationForm.vue';

import ChannelDefs from '@/store/channel/channel.d';
import LayoutDefs from '@/store/layout/layout.d';

const {
  mapActions: mapChannelActions,
  mapMutations: mapChannelMutations,
  mapState: mapChannelState
} = createNamespacedHelpers('Channel');

const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

const {
  mapState: mapLayoutState,
  mapActions: mapLayoutActions
} = createNamespacedHelpers('Layout');

export default {
  name: 'ChannelAction',
  mixins: [clickAway],
  props: {
    isPremium: Boolean
  },
  components: {
    IconChats,
    IconTransfer,
    IconClose,
    IconBooking,
    ModalTransferChannel,
    ModalReservationForm
  },
  data: function() {
    return {
      isChannelMenuShown: false,
      isTransferModalShown: false
    };
  },
  computed: {
    ...mapChannelState({
      currentChannel: state => state.currentChannel,

      isWaiting: function(state) {
        const { status } = state.currentChannel;
        return status === 'waiting';
      },

      isArchived: function(state) {
        const { status } = state.currentChannel;
        return status === 'archived';
      },

      isActive: function(state) {
        const { status } = state.currentChannel;
        return status === 'active';
      },

      isOwned: function(state) {
        const { status, agentId } = state.currentChannel || {};
        return status === 'active' && agentId === this.currentConcierge.agentId;
      }
    }),

    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge,

      isAllowedAccess: function(state) {
        return state.currentConcierge.conciergeLevel >= 199;
      }
    }),

    ...mapLayoutState({
      modal: state => state.modal
    })
  },
  methods: {
    ...mapChannelActions({
      channelStore_pickChannel: ChannelDefs.actions.pickChannel,
      channelStore_leaveChannel: ChannelDefs.actions.leaveChannel
    }),

    ...mapLayoutActions({
      layoutStore_openModal: LayoutDefs.actions.openModal,
      layoutStore_setCurrentTab: LayoutDefs.actions.setCurrentTab
    }),

    hideChannelMenu: function() {
      this.isChannelMenuShown = false;
    },

    showChannelMenu: function() {
      this.isChannelMenuShown = true;
    },

    ...mapChannelMutations({
      channelStore_SetCurrentChannelStatus:
        ChannelDefs.mutations.setCurrentChannelStatus
    }),

    pickChannel: async function() {
      await this.channelStore_pickChannel();
      this.$emit('update-current-tab', { tab: 'own' });
    },

    openTransferModal: function() {
      this.layoutStore_openModal({ module: 'transfer' });
    },

    openReservationModal: function() {
      this.layoutStore_openModal({ module: 'addReservationForm' });
    },

    closeChannel: async function() {
      this.channelStore_leaveChannel();
      this.$emit('update-current-tab', { tab: 'own' });
    }
  }
};
